// Utility to detect user country and cache result in memory
let cachedCountryInfo = null

/**
 * Detects the user's country using https://apip.cc/json and caches the result for the session.
 * @returns {Promise<string|null>} The country code (e.g., 'CO') or null if detection fails.
 */
export async function detectUserCountry() {
    const info = await detectUserCountryInfo()
    return info?.countryCode || null
}

/**
 * Detects the user's country data using https://apip.cc/json and caches the result for the session.
 * @returns {Promise<{countryCode: string, countryName: string}|null>} Country code/name or null.
 */
export async function detectUserCountryInfo() {
    if (cachedCountryInfo) return cachedCountryInfo
    try {
        const response = await fetch('https://apip.cc/json')
        if (!response.ok) throw new Error('Failed to fetch country')
        const data = await response.json()
        const countryCode =
            typeof data.CountryCode === 'string'
                ? data.CountryCode.trim().toUpperCase()
                : ''
        const countryName =
            typeof data.CountryName === 'string' ? data.CountryName.trim() : ''

        if (!countryCode) return null

        cachedCountryInfo = {
            countryCode,
            countryName,
        }
        return cachedCountryInfo
    } catch (error) {
        console.error('Error detecting country:', error)
        return null
    }
}
